import { Box, Divider, Grid, Typography } from "@mui/material";
import { PropsWithChildren, useState } from "react";
import {
  ArrowDropDownOutlined,
  ArrowDropUpOutlined,
} from "@mui/icons-material";

type Props = {
  openText: string;
  closeText: string;
};

const EntryCollapse = ({
  children,
  openText,
  closeText,
}: PropsWithChildren<Props>) => {
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: "20px",
            "&:hover": { cursor: "pointer" },
          }}
          onClick={() => setOpen(!open)}
        >
          {open ? (
            <>
              <Typography
                variant="header"
                color="primary"
                fontSize="14px"
                fontWeight={700}
              >
                {closeText}
              </Typography>
              <ArrowDropUpOutlined color="primary" />
            </>
          ) : (
            <>
              <Typography
                variant="header"
                color="primary"
                fontSize="14px"
                fontWeight={700}
              >
                {openText}
              </Typography>
              <ArrowDropDownOutlined color="primary" />
            </>
          )}
        </Box>
      </Box>
      {open && (
        <Grid
          container
          sx={{
            display: "flex",
          }}
        >
          <Grid
            item
            xs={4}
            margin={0}
            padding={0}
            sx={{
              paddingRight: "15px",
            }}
          >
            <Box>{children}</Box>
          </Grid>
          <Divider
            sx={{
              marginTop: "16px",
              marginBottom: "16px",
            }}
          />
        </Grid>
      )}
    </Box>
  );
};

export default EntryCollapse;
